import { Button } from "d-react-components";
import { useContext, useMemo } from "react";

import { IMPORT_WAREHOUSE_STEPS } from "@constants/warehouse";
import AppContext from "@helpers/context";
import { useTranslation } from "react-i18next";
import { INIT_IMPORT_FORM } from "./WarehouseImport";

const WarehouseImportFooter = () => {
  const { stepIndex, setStepIndex, formImport } = useContext(AppContext);
  const stepNextValue = useMemo(
    () => IMPORT_WAREHOUSE_STEPS[stepIndex + 1],
    [stepIndex]
  );
  const classNameFooter =
    "d-flex justify-content-end align-items-center p-4 bg-gray-light";
  const { t } = useTranslation();

  const getDisabledNextStep = () => {
    const { importType, importFields, fileImport } = formImport.values;
    const { data, errors } = fileImport ?? {};

    switch (stepIndex) {
      case 0:
        return !importType || importFields.length === 0;
      case 1:
        return !data;
      case 2:
        return !errors || errors?.length !== 0;
      default:
        return false;
    }
  };

  const onClickResetDefault = () => {
    setStepIndex(0);
    formImport.setValues(INIT_IMPORT_FORM);
  };

  if (stepIndex === 3) {
    return (
      <div className={classNameFooter}>
        <Button onClick={onClickResetDefault}>{t("newImport")}</Button>
      </div>
    );
  }

  return (
    <div className={classNameFooter}>
      {stepIndex !== 0 && (
        <Button
          variant="outline"
          iconName="chevron_left"
          className="mr-3"
          onClick={() => setStepIndex(stepIndex - 1)}
        >
          {t("previousStep")}
        </Button>
      )}
      <Button
        disabled={getDisabledNextStep()}
        onClick={() => setStepIndex(stepIndex + 1)}
      >{`Step ${stepIndex + 2}: ${t(stepNextValue?.title)}`}</Button>
    </div>
  );
};

export default WarehouseImportFooter;
